// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Quvs","itemTitle":"ClientEmergencyInfo_itemTitle__YrygT","itemText":"ClientEmergencyInfo_itemText__Ckxb9"};